const SESSION_KEY = 'user_auth';
const EXPIRE_TIME = 8 * 60 * 60 * 1000; // 8 hours in milliseconds

export const setLoginSession = (userData) => {
  const sessionData = {
    user: userData,
    expiry: new Date().getTime() + EXPIRE_TIME,
  };
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(sessionData));
};

export const isAuthenticated = () => {
  const sessionStr = sessionStorage.getItem(SESSION_KEY);
  if (!sessionStr) return false;

  const session = JSON.parse(sessionStr);
  const now = new Date().getTime();

  if (now > session.expiry) {
    sessionStorage.removeItem(SESSION_KEY);
    return false;
  }
  return true;
};